import request from '@/api/axios';

export function getCouponInfo(params) {
	return request({
		url: '/api/coupon/getCouponInfo',
		method: 'get',
		params,
	});
}

export function getAvailableCoupon(params) {
	return request({
		url: '/api/coupon/getAvailableCoupon',
		method: 'get',
		params,
	});
}

export function receiveCoupons(data) {
	return request({
		url: '/api/coupon/receiveCoupons',
		method: 'post',
		data,
	});
}
